import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { errorMessage } from '../api/client';
import { useChangePassword, useLogout } from '../api/queries';
import { useAuth } from '../auth/AuthContext';
import { useToast } from '../components/toast';
import { Alert, Button, Card, Field, Input, KeyValue, PageHeader } from '../components/ui';
import { ROLE_LABEL } from '../lib/labels';
import { usePageTitle } from '../lib/title';

export function SettingsPage() {
  usePageTitle('설정');
  const { user, org } = useAuth();
  const change = useChangePassword();
  const logout = useLogout();
  const navigate = useNavigate();
  const toast = useToast();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    if (next.length < 8) return setError('새 비밀번호는 8자 이상이어야 합니다');
    if (next !== confirm) return setError('새 비밀번호가 서로 다릅니다');
    change.mutate(
      { current, next },
      {
        onSuccess: () => {
          toast.success('비밀번호를 변경했습니다');
          setCurrent('');
          setNext('');
          setConfirm('');
        },
        onError: (err) => setError(errorMessage(err)),
      },
    );
  };

  return (
    <div className="space-y-6">
      <PageHeader title="설정" />
      <div className="grid gap-6 md:grid-cols-2">
        <Card title="내 계정">
          <KeyValue
            items={[
              ['이름', user.name],
              ['이메일', user.email],
              ['역할', ROLE_LABEL[user.role]],
              ['조직', org.name],
            ]}
          />
          <Button
            className="mt-4"
            onClick={() => logout.mutate(undefined, { onSettled: () => navigate('/login') })}
          >
            로그아웃
          </Button>
        </Card>
        <Card title="비밀번호 변경">
          <form onSubmit={submit} className="space-y-3">
            <Field label="현재 비밀번호" required>
              <Input
                type="password"
                autoComplete="current-password"
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
                required
              />
            </Field>
            <Field label="새 비밀번호" required hint="8자 이상">
              <Input
                type="password"
                autoComplete="new-password"
                value={next}
                onChange={(e) => setNext(e.target.value)}
                required
              />
            </Field>
            <Field label="새 비밀번호 확인" required>
              <Input
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </Field>
            {error && <Alert level="error">{error}</Alert>}
            <Button type="submit" variant="primary" loading={change.isPending}>
              변경
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
